"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBlueprintLibrary = require("react-blueprint-library");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var SearchBar = props => {
  var _props$scfields$searc;
  var [query, setQuery] = (0, _react.useState)({
    currentValue: props.searchterm,
    inputChanged: false,
    userInput: '',
    index: -1
  });
  /* query object has 4 attributes:
      - current value: this starts as the original user input, and updates as a user iterates through the suggested searches
      - input changed: a boolean that will be true when a user has modified the original input
      - user input: the original typed-in user input
      - index: used to record where a user is located when navigating through the suggestion box and search bar
  */
  var [suggestions, setSuggestions] = (0, _react.useState)([]);
  var [display, setDisplay] = (0, _react.useState)(false);
  var [error, setError] = (0, _react.useState)(null);
  var [isLoaded, setIsLoaded] = (0, _react.useState)(false);
  var placeholder = props.scfields.placeholderText.value === undefined ? 'Search Massmutual...' : props.scfields.placeholderText.value;
  var urlPath = (_props$scfields$searc = props.scfields.searchUrl) === null || _props$scfields$searc === void 0 ? void 0 : _props$scfields$searc.value;
  (0, _react.useEffect)(() => {
    if (query.inputChanged) {
      fetch("/apicalls/suggestedresults?searchterm=".concat(query.currentValue)).then(res => res.json()).then(result => {
        setIsLoaded(true);
        setSuggestions(result);
      }, error => {
        setIsLoaded(false);
        setError(error);
      });
    }
  }, [query]);
  var handleChange = event => {
    setQuery({
      currentValue: event.target.value,
      inputChanged: true,
      userInput: event.target.value,
      index: -1
    });
    setDisplay(true);
  };
  var showResults = () => {
    if (!(0, _lodash.isEmpty)(query.currentValue)) {
      window.history.pushState({
        path: "".concat(urlPath, "?query=").concat(query.currentValue, "&page=1")
      }, '', "".concat(urlPath, "?query=").concat(query.currentValue, "&page=1"));
      setDisplay(false);
      props.showresults(query.currentValue);
    }
  };
  var selectResult = event => {
    if (!(0, _lodash.isEmpty)(event.currentTarget.value)) {
      window.history.pushState({
        path: "".concat(urlPath, "?query=").concat(event.currentTarget.value, "&page=1")
      }, '', "".concat(urlPath, "?query=").concat(event.currentTarget.value, "&page=1"));
      setQuery({
        currentValue: event.currentTarget.value,
        inputChanged: false,
        userInput: event.currentTarget.value,
        index: query.index
      });
      setDisplay(false);
      props.showresults(event.currentTarget.value);
    }
  };
  var handleKeyPress = event => {
    var newUserInput = query;
    var curIdx = newUserInput.index;
    var curInput = newUserInput.userInput;
    if (event.keyCode === 13) {
      showResults();
      return;
    }
    if (event.keyCode === 38) {
      var _suggestions$getsugge, _suggestions$getsugge2;
      curIdx = curIdx === -1 ? ((_suggestions$getsugge = suggestions.getsuggestions) === null || _suggestions$getsugge === void 0 || (_suggestions$getsugge = _suggestions$getsugge.suggestions) === null || _suggestions$getsugge === void 0 ? void 0 : _suggestions$getsugge.length) - 1 : curIdx - 1;
      curInput = curIdx === -1 ? curInput : (_suggestions$getsugge2 = suggestions.getsuggestions) === null || _suggestions$getsugge2 === void 0 || (_suggestions$getsugge2 = _suggestions$getsugge2.suggestions[curIdx]) === null || _suggestions$getsugge2 === void 0 ? void 0 : _suggestions$getsugge2.title;
    }
    if (event.keyCode === 40) {
      var _suggestions$getsugge3, _suggestions$getsugge4;
      curIdx = curIdx === ((_suggestions$getsugge3 = suggestions.getsuggestions) === null || _suggestions$getsugge3 === void 0 || (_suggestions$getsugge3 = _suggestions$getsugge3.suggestions) === null || _suggestions$getsugge3 === void 0 ? void 0 : _suggestions$getsugge3.length) - 1 ? -1 : curIdx + 1;
      curInput = curIdx === -1 ? curInput : (_suggestions$getsugge4 = suggestions.getsuggestions) === null || _suggestions$getsugge4 === void 0 || (_suggestions$getsugge4 = _suggestions$getsugge4.suggestions[curIdx]) === null || _suggestions$getsugge4 === void 0 ? void 0 : _suggestions$getsugge4.title;
    }
    setQuery({
      currentValue: curInput,
      inputChanged: false,
      userInput: query.userInput,
      index: curIdx
    });
  };
  var renderSuggestion = () => {
    var _suggestions$getsugge5;
    if (((_suggestions$getsugge5 = suggestions.getsuggestions) === null || _suggestions$getsugge5 === void 0 ? void 0 : _suggestions$getsugge5.suggestions.length) > 0 && display) {
      var _suggestions$getsugge6;
      return /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: "0",
        className: "list-group sch-div"
      }, (0, _lodash.map)((_suggestions$getsugge6 = suggestions.getsuggestions) === null || _suggestions$getsugge6 === void 0 ? void 0 : _suggestions$getsugge6.suggestions, (itm, idx) => {
        var lId = "auto-suggest--item".concat(idx);
        var title = itm.title;
        var regEx = new RegExp("(" + (0, _lodash.escapeRegExp)(query.userInput) + ")", "ig");
        var match = title.replace(regEx, "<b class=\"sch-bold\">$1</b>");
        if (idx === query.index) {
          return /*#__PURE__*/_react.default.createElement("button", {
            key: "btn-item".concat(idx),
            id: lId,
            value: itm.title,
            onClick: selectResult,
            className: "list-group-item list-group-item-action sch-button sch-list-grp sch-button-active"
          }, (0, _htmlReactParser.default)(match));
        } else {
          return /*#__PURE__*/_react.default.createElement("button", {
            key: "btn-item".concat(idx),
            id: lId,
            value: itm.title,
            onClick: selectResult,
            className: "list-group-item list-group-item-action sch-button sch-list-grp"
          }, (0, _htmlReactParser.default)(match));
        }
      }));
    }
    ;
  };
  return /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "container searchinput-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "suggestionform"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/_react.default.createElement("input", {
    "aria-describedby": "search-clear-addon",
    "aria-label": "Search Term",
    className: "form-control",
    id: "search-explicit-clear",
    onChange: handleChange,
    onKeyDown: handleKeyPress,
    placeholder: placeholder,
    type: "text",
    value: query.currentValue
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-primary",
    type: "button",
    id: "search-clear-addon",
    onClick: showResults
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Search"), /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-search",
    "aria-hidden": "true",
    title: "Search"
  })))), renderSuggestion())))));
};
var _default = exports.default = SearchBar;